import { useEffect, useState } from 'react';

import BaseSecuritiesModal, {
  BaseSecuritiesModalProps,
} from 'global/Securities/components/Modal/BaseSecuritiesModal';

import { ContentContainer, TnCFrame, TnCFrameWrapper } from './styled';
import { useBondTransaction } from '../../stores/useBondTransaction';
import { useBondsModalStore } from '../../stores/useBondsModalStore';
import TnCContent from './TnCContent';
import useBondsAnalytics from '../../useBondsAnalytics';

interface Props extends BaseSecuritiesModalProps {
  checkboxText?: string;
}

export default function ModalBondTnC({ ...props }: Readonly<Props>) {
  const [isReachedBottom, setReachingBottom] = useState<boolean>(false);
  const acceptTnC = useBondTransaction((s) => s.setTnC);
  const closeModal = useBondsModalStore((s) => s.closeModal);
  const { FRBondActionTrackers } = useBondsAnalytics();

  const handleTncSubmit = async () => {
    if (!isReachedBottom) {
      return;
    }
    acceptTnC(true);
    FRBondActionTrackers.onTnCConfirmed();
    closeModal();
  };

  const handleReachedBottom = () => {
    setReachingBottom(true);
  };

  useEffect(
    () => () => {
      setReachingBottom(false);
    },
    [],
  );

  return (
    <BaseSecuritiesModal
      title="Syarat & Ketentuan"
      submitText="Saya Setuju"
      submitProps={{ disabled: !isReachedBottom, loading: false }}
      onSubmit={handleTncSubmit}
      {...props}
    >
      <ContentContainer>
        <TnCFrameWrapper>
          <TnCFrame>
            <TnCContent onReachedBottom={handleReachedBottom} />
          </TnCFrame>
        </TnCFrameWrapper>
      </ContentContainer>
    </BaseSecuritiesModal>
  );
}
